module.exports = __webpack_public_path__ + "static/media/CasinoMeter1.30484d42.png";